import React, {Component} from 'react';

export default class AudioContent extends Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event) {
    event.preventDefault();
    if(window.vexpo && window.vexpo.overlay)
      window.vexpo.overlay(this.props);
  }
  /** @function
   * Renders the Audio Content component.
   */
  render() {
    if(this.props.thumbnail !== undefined) {
      return (
        <div onClick={this.handleClick}>
          <img src={this.props.thumbnail} alt={this.props.name}/>
        </div>
      );
    } else {
      return (
        <div style={{textAlign: 'center'}}>
          <audio src={this.props.audio} autoPlay="true" controls="true"/><br/>
          {this.props.name}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/content/audio-content.js